import { useEffect, useMemo, useState } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import DatePicker, { registerLocale } from 'react-datepicker';
import es from 'date-fns/locale/es';
import 'react-datepicker/dist/react-datepicker.css';
import { Button } from 'primereact/button';
import cashPaymentImage from '../../../assets/images/payment-cash-minimal.svg';
import cardPaymentImage from '../../../assets/images/payment-card-minimal.svg';

registerLocale('es', es);

const OTHER_ZONE_VALUE = 'OTHER';

function CapturePos() {
  const [consecutive] = useState('100001');
  const [captureDate, setCaptureDate] = useState(new Date());
  const [vehicleTypes, setVehicleTypes] = useState([]);
  const [vehicleTypeId, setVehicleTypeId] = useState('');
  const [zones, setZones] = useState([]);
  const [zoneId, setZoneId] = useState('');
  const [price, setPrice] = useState('');
  const [destination, setDestination] = useState('');

  const isOtherZoneSelected = zoneId === OTHER_ZONE_VALUE;

  const computedPrice = useMemo(() => {
    const vehicleTypeNum = Number(vehicleTypeId);
    const zoneNum = Number(zoneId);

    if (!Number.isFinite(vehicleTypeNum) || !Number.isFinite(zoneNum)) {
      return '';
    }

    return String(vehicleTypeNum + zoneNum);
  }, [vehicleTypeId, zoneId]);

  useEffect(() => {
    getVehicleTypes();
    getZones();
  }, []);

  useEffect(() => {
    if (isOtherZoneSelected) {
      return;
    }

    setPrice(computedPrice);
  }, [computedPrice, isOtherZoneSelected]);

  const getVehicleTypes = () => {
    fetch(`${process.env.REACT_APP_API_URL}/vehicleType/cmb?generic=false`)
      .then(response => response.json())
      .then(data => {
        if (data.responseCode === 'OK') {
          setVehicleTypes(data.responseObject);
        }
      });
  };

  const getZones = () => {
    fetch(`${process.env.REACT_APP_API_URL}/zone/cmb`)
      .then(response => response.json())
      .then(data => {
        if (data.responseCode === 'OK') {
          setZones(data.responseObject);
        }
      });
  };

  const onZoneChange = (event) => {
    const nextZoneId = event.target.value;
    setZoneId(nextZoneId);

    if (nextZoneId === OTHER_ZONE_VALUE) {
      setPrice('');
    }
  };

  const onAddClick = () => {
    // Sin funcionalidad por el momento.
  };

  return (
    <article>
      <Row>
        <Col>
          <h1 className="app-font">Captura POS</h1>
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <div className="card">
            <div className="card-body p-3">
              <table className="table table-sm table-bordered table-striped align-middle mb-0">
                <thead className="table-light">
                  <tr>
                    <th className="text-start w-25">Campo</th>
                    <th className="text-start">Valor</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th className="text-start w-25">Consecutivo</th>
                    <td>
                      <Form.Control
                        type="text"
                        value={consecutive}
                        disabled
                        style={{ width: '12ch' }}
                      />
                    </td>
                  </tr>
                  <tr>
                    <th className="text-start w-25">Fecha</th>
                    <td>
                      <DatePicker
                        selected={captureDate}
                        onChange={(date) => setCaptureDate(date)}
                        showTimeSelect
                        timeFormat="HH:mm"
                        timeIntervals={15}
                        dateFormat="dd/MM/yyyy HH:mm"
                        locale="es"
                        className="app_datepicker"
                        placeholderText="Selecciona fecha y hora"
                      />
                    </td>
                  </tr>
                  <tr>
                    <th className="text-start w-25">Tipo de vehículo</th>
                    <td>
                      <Form.Select
                        value={vehicleTypeId}
                        onChange={(event) => setVehicleTypeId(event.target.value)}
                        style={{ width: '50ch' }}>
                        <option value="">Selecciona el tipo</option>
                        {vehicleTypes.map((vehicleType) => (
                          <option key={vehicleType.vehicleTypeId} value={vehicleType.vehicleTypeId}>
                            {vehicleType.description}
                          </option>
                        ))}
                      </Form.Select>
                    </td>
                  </tr>
                  <tr>
                    <th className="text-start w-25">Zona</th>
                    <td>
                      <Form.Select
                        value={zoneId}
                        onChange={onZoneChange}
                        style={{ width: '50ch' }}>
                        <option value="">Selecciona una zona</option>
                        {zones.map((zone) => (
                          <option key={zone.zoneId} value={zone.zoneId}>
                            {zone.description}
                          </option>
                        ))}
                        <option value={OTHER_ZONE_VALUE}>Otro</option>
                      </Form.Select>
                    </td>
                  </tr>
                  <tr>
                    <th className="text-start w-25">Precio</th>
                    <td>
                      <Form.Control
                        type="number"
                        step="0.01"
                        value={price}
                        onChange={(event) => setPrice(event.target.value)}
                        disabled={!isOtherZoneSelected}
                        style={{ width: '12ch' }}
                        placeholder="0.00"
                      />
                    </td>
                  </tr>
                  <tr>
                    <th className="text-start w-25">Destino</th>
                    <td>
                      <Form.Control
                        as="textarea"
                        rows={3}
                        maxLength={150}
                        value={destination}
                        onChange={(event) => setDestination(event.target.value)}
                        placeholder="Ingresa destino"
                        style={{ maxWidth: '60ch' }}
                      />
                    </td>
                  </tr>
                  <tr>
                    <th className="text-start w-25">Forma de pago</th>
                    <td>
                      <div className="d-flex gap-3 flex-wrap">
                        <button type="button" className="btn btn-outline-secondary p-2">
                          <img
                            src={cashPaymentImage}
                            alt="Efectivo"
                            style={{ width: '104px', height: '60px', objectFit: 'contain' }}
                          />
                        </button>
                        <button type="button" className="btn btn-outline-secondary p-2">
                          <img
                            src={cardPaymentImage}
                            alt="Credito/Débito"
                            style={{ width: '92px', height: '70px', objectFit: 'contain' }}
                          />
                        </button>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th className="text-start w-25"></th>
                    <td>
                      <Button
                        className="p-button-raised p-button-sm"
                        label="Agregar"
                        aria-label="Agregar"
                        onClick={onAddClick}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </Col>
      </Row>
    </article>
  );
}

export default CapturePos;
